<div class='d-flex py-1'>
  <label class="col-4 form-control-label" for="externalAgencySelect">External Review Agency:</label>
  <div class="col-8 no-borders" [formGroup]="userForm">
    <select class="form-control" name="externalAgency" id="externalAgencySelect" (change)="selectedAgecyChange($event)" formControlName="agency">
      <option value="null" disabled>Select an agency</option>
      <option [value]="led.code">{{led.name}}</option>
      <option [value]="ldr.code">{{ldr.name}}</option>
      <option [value]="lga.code">{{lga.name}}</option>
      <option [value]="lwc.code">{{lwc.name}}</option>
      <option [value]="lic.code">{{lic.name}}</option>
    </select>
  </div>
</div>

<shr-person [form]="userForm" [person]="user" [addressRequired]="false"></shr-person>

<div *ngIf="selectedAgency === lga.code || selectedAgency === lic.code" class="py-1">
  <div class='d-flex'>
    <label class="col-4 form-control-label" for="governing-parish-select" id="governing-parish-label">Governing Parish :</label>
    <div class="col-8">
      <shr-parish [(parish)]="user.governingParish" [readonly]="false" [form]="form" [controlId]="'governing-parish-select'" [labelledBy]="'governing-parish-label'"></shr-parish>
    </div>
  </div>
</div>
